import { type AppBrand, appBrands } from '../brands'
import { currentAppBrand } from '../current-brand'
import { features as aladinFeatures } from './aladin'
import { features as countrymaltFeatures } from './countrymalt'
import { allFeaturesAtFalse, type Features } from './default'
import { features as episensFeatures } from './episens'
import { features as farmiFeatures } from './farmi'

export type { Features, HomeAnchor, LegalLink } from './default'

function featuresForBrand(appBrand: AppBrand): Features {
  switch (appBrand) {
    case appBrands.Aladin:
      return aladinFeatures
    case appBrands.Farmi:
      return farmiFeatures
    case appBrands.Episens:
      return episensFeatures
    case appBrands.Countrymalt:
      return countrymaltFeatures
    default:
      return allFeaturesAtFalse
  }
}

export const featuresForCurrentBrand = featuresForBrand(currentAppBrand)
